import { defineAsyncComponent } from 'vue'
export default {
  print: defineAsyncComponent(() => import("/home/bun/app/layouts/_print.vue").then(m => m.default || m)),
  application: defineAsyncComponent(() => import("/home/bun/app/layouts/application.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/bun/app/layouts/default.vue").then(m => m.default || m))
}